import { ActionIcon, Tooltip } from '@mantine/core';
import { IconExclamationCircle } from '@tabler/icons-react';
import * as React from 'react';
import { useParams } from 'react-router-dom';
import { Show } from '../../../../../react-commons/components/control-flow/Show';
import { OpenModal } from '../../../../../react-commons/utils/modals/openModal';
import { ResourceType } from '../../../resource/enumerations/ResourceType';
import { useUserActions } from '../../../resource/resources/persistables/user/userResource';
import { DetailedValidationResource } from '../../../resource/resources/validation/detailedValidationResource';
import { TOOLTIPS } from '../../../resource/tooltipTexts';
import { useUserId } from '../../authentication/useUserId';
import { ResourceDetailsWithMultiValidationDialogContent } from '../dialogs/validation/ResourceDetailsWithMultiValidationDialogContent';

export const ResourceDetailsWithMultiValidationButton = ({
    resourceValidationResults,
    resourceType,
                                                             openWithoutValidation,
                                                             disabled
}: {
    resourceValidationResults?: DetailedValidationResource[] | null;
    resourceType: ResourceType | ResourceType[] | undefined;
    openWithoutValidation?: boolean;
    disabled?: boolean;
}) => {
    const userId = useUserId('');
    const { id: projectId } = useParams<{ id: string }>();

    const userActions = useUserActions();
    const userSystemRights = userActions.useGetUserEffectiveRightsOfUser(userId, projectId);
    const isProcessAdmin = userSystemRights.data?.isProcessAdmin;

    const openValidationDialog = () => {
        if (resourceType) {
            OpenModal.ContentModal({
                title: 'Resource Information',
                content: (
                    <ResourceDetailsWithMultiValidationDialogContent
                        resourceValidations={openWithoutValidation ? null : resourceValidationResults?.filter(Boolean)}
                        resourceType={resourceType}
                    />
                ),
            });
        }
    };

    const fillColor = () => {
        if (resourceValidationResults) {
            if (resourceValidationResults.filter((value) => value?.maxSeverity === 'CRITICAL').length > 0) {
                return 'var(--mantine-color-error)';
            } else if (resourceValidationResults.filter((value) => value?.maxSeverity === 'WARNING').length > 0) {
                return 'var(--mantine-color-warning)';
            } else if (resourceValidationResults.filter((value) => value?.maxSeverity === 'NOTE').length > 0) {
                return 'var(--mantine-color-info)';
            }
        }
        return 'var(--mantine-color-base-button)';
    };

    if (!resourceType) {
        return <div />;
    }

    return (
        <Show when={isProcessAdmin}>
            <Tooltip label={TOOLTIPS.VALIDATION_RESULT}>
                <ActionIcon
                    size={'sm'}
                    style={{ padding: '6px', backgroundColor: 'inherit' }}
                    variant={'transparent'}
                    onClick={openValidationDialog}
                    disabled={disabled}
                >
                    <IconExclamationCircle color={fillColor()} />
                </ActionIcon>
            </Tooltip>
        </Show>
    );
};
